module.exports = __webpack_public_path__ + "img/logo-placeholder.423a9165.jpg";